<div class="w-100 d-flex flex-wrap justify-content-center">
  <div class="w-100 d-flex flex-wrap chart-info-container">
    <p class="w-100 b-2 text-onback-medium">کل موجودی</p>
    <p class="w-100 b-2 text-onback-high mt-plus">
      <span class="st-1">
        {{ wallet()?.balance | thousands }}
      </span>
      <span class="b-2"> ریال </span>
    </p>

    <wealth-applet-assets-bar
      class="w-100"
      [config]="barConfig()"
    />
  </div>

  <div class="w-100 d-flex flex-column gap-minus mt-big d-flex flex-wrap">
    <p class="d-flex align-items-center text-onback-medium l-1 d-flex gap-small">
      <span class="bullet surface-brand"></span>
      موجودی قابل برداشت : {{ wallet()?.withdrawalBalance | thousands }} ریال
    </p>
    <p class="d-flex align-items-center text-onback-medium l-1 d-flex gap-small">
      <span class="bullet back-oninvert-warning"></span>
      موجودی غیر قابل برداشت :
      {{ wallet()?.uncollectibleBalance | thousands }} ریال
    </p>
  </div>
</div>
